import { formatCurrency } from "@poseidon/utils/currency";
import React from "react";
import { Panel } from "@poseidon/ui/components/Panel";
import LinearProgress from "@mui/material/LinearProgress";
import Table from "@mui/material/Table";
import TableHead from "@mui/material/TableHead";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import { RateTypeChip } from "./RateTypeChip";

export const SchedulesTable = ({ schedules, loading, error }) => {
  return (
    <Panel nopadding expandable title="Schedules">
      {loading && <LinearProgress />}
      {error && "Error!"}
      {!loading && !error && (
        <Table>
          <TableHead>
            <TableRow>
              <TableCell component="th">Status</TableCell>
              <TableCell component="th">Started</TableCell>
              <TableCell component="th">Principal</TableCell>
              <TableCell component="th">Monthly Payment</TableCell>
              <TableCell component="th">Rate</TableCell>
              <TableCell component="th">Term</TableCell>
              <TableCell component="th">Arrears</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {schedules.map((trans) => (
              <TableRow key={trans.id}>
                <TableCell>{trans.status}</TableCell>
                <TableCell>
                  {trans.startDate.toLocaleDateString("en-GB")}
                </TableCell>
                <TableCell>
                  {formatCurrency(trans.parameters.principal)}
                </TableCell>
                <TableCell>
                  {formatCurrency(trans.parameters.monthlyPayment, true)}
                </TableCell>
                <TableCell>
                  {trans.parameters.rate}%
                  <RateTypeChip
                    fixedRate={trans.parameters.fixedRate}
                    sx={{ ml: 1 }}
                  />
                </TableCell>
                <TableCell>{Math.ceil(trans.parameters.term)}</TableCell>
                <TableCell>
                  {trans.duePayments > 0
                    ? `${formatCurrency(trans.arrears)} (${
                        trans.duePayments
                      } payment${trans.duePayments > 1 ? "s" : ""})`
                    : "-"}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      )}
    </Panel>
  );
};
